import { getAssetImageUrl } from '@util/common.js';
import PropTypes from 'prop-types';
import { Carousel } from 'react-responsive-carousel';
import ArrowRightButton from '@components/buttons/arrow-right.button.jsx';
import ArrowLeftButton from '@components/buttons/arrow-left.button.jsx';
import { NavLink } from 'react-router';
import { useCallback, useState } from 'preact/hooks';
import CardBadge from '@components/shared/cards/components/card-badge.jsx';
import './card.scss';

CarouselCard.propTypes = {
  items: PropTypes.array,
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool,
  onGrid: PropTypes.bool,
  className: PropTypes.string,
};

export default function CarouselCard({
  items = [],
  isFirst = false,
  isLast = false,
  className = '',
  onGrid = true,
}) {
  const [currentProductIndex, setCurrentProductIndex] = useState(0);
  const [cardHover, setCardHover] = useState(false);

  if (onGrid) {
    if (isFirst) className = `${className} md:col-span-2`;
    if (isLast) className = `${className} lg:col-span-2 2xl:col-span-1`;
  }

  const onChange = useCallback((index) => {
    setCurrentProductIndex(index);
  }, []);

  const hoverHandler = () => {
    setCardHover(!cardHover);
  };

  const goNext = useCallback(() => {
    const nextIndex = currentProductIndex + 1;
    if (nextIndex >= items.length) {
      setCurrentProductIndex(0);
    } else {
      setCurrentProductIndex(nextIndex);
    }
  }, [currentProductIndex]);

  const goPrev = useCallback(() => {
    const prevIndex = currentProductIndex - 1;
    if (prevIndex < 0) {
      setCurrentProductIndex(items.length - 1);
    } else {
      setCurrentProductIndex(prevIndex);
    }
  }, [currentProductIndex]);

  return (
    <div className={className}>
      <NavLink
        className="h-full"
        unstable_viewTransition
        to={items[currentProductIndex].link}
      >
        <div
          className="card carousel-card border-base-200 border-2 rounded-xl overflow-hidden bg-base-200 hover:bg-base-300 transition-colors shadow-2xl hover:shadow-3xl  relative h-full"
          onMouseOver={hoverHandler}
          onMouseOut={hoverHandler}
        >
          <Carousel
            autoPlay={true}
            showIndicators={false}
            showStatus={false}
            infiniteLoop={true}
            showThumbs={false}
            interval={5000}
            onChange={onChange}
            showArrows={false}
            selectedItem={currentProductIndex}
          >
            {items.map((product) => (
              <div key={product.name} className="text-left relative h-full">
                <div className="flex flex-row justify-between px-0 pt-0 pb-0 h-20">
                  <div className="basis-1/2 px-4 py-3">
                    <img
                      className="h-full w-auto object-contain"
                      src={getAssetImageUrl(product.thumbnail)}
                      alt="Thumbnail"
                    />
                  </div>
                  <div className="basis-1/4">
                    <CardBadge badges={product} />
                  </div>
                </div>

                <div className="card-body bg-base-100 h-[266px]">
                  <h2 className="card-title text-2xl font-extrabold">
                    {product.name}
                  </h2>
                  <p className="prose mb-2 mt-4">{product.shortDescription}</p>
                </div>
              </div>
            ))}
          </Carousel>
          <div className="absolute left-5 right-5 bottom-8 flex items-center">
            <ArrowLeftButton onClick={goPrev} />
            <span className="flex-grow"></span>
            <ArrowRightButton onClick={goNext} />
          </div>
          <div className="absolute bottom-5 left-1 right-1 flex justify-center items-center">
            {items.map((product) =>
              product.name === items[currentProductIndex].name ? (
                <div
                  key={product.name}
                  className="badge badge-secondary badge-xs mx-1"
                ></div>
              ) : (
                <div
                  key={product.name}
                  className="badge badge-secondary opacity-20 badge-xs mx-1"
                ></div>
              )
            )}
          </div>
        </div>
      </NavLink>
    </div>
  );
}
